import {
  LBInfoCircleIcon,
  LBTooltip,
  LBTooltipTrigger,
  LBTooltipContent,
  LBTooltipProvider
} from '@linearb/buzz'

interface InfoTooltipProps {
  text: string
}

// Muted info icon that reveals `text` on hover.
const InfoTooltip: React.FC<InfoTooltipProps> = ({ text }) => (
  <LBTooltipProvider>
    <LBTooltip>
      <LBTooltipTrigger asChild>
        <span className='inline-flex shrink-0'>
          <LBInfoCircleIcon className='h-3.5 w-3.5 text-muted-foreground cursor-help' />
        </span>
      </LBTooltipTrigger>
      <LBTooltipContent className='max-w-sm'>{text}</LBTooltipContent>
    </LBTooltip>
  </LBTooltipProvider>
)

export default InfoTooltip
